// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"56d60458","455":"2ec28f42","977":"ac5ed997"}[chunkId] + ".chunk.js";
};